class SectionRecommended extends HTMLElement {
  
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.loadSection();
  }

  loadSection = () => {
    axios.get(this.dataset.url)
      .then((response) => {
        const doc = Utils.getDocument(response.data);
        const section = doc.querySelector('section-recommended');
        this.innerHTML = section.innerHTML;
        this.reinitializeCustomElements();
      })
      .catch((error) => {
        Utils.errorHanlder(error);
      })
      .finally(() => {});
  }

  reinitializeCustomElements = () => {
    const breakpoints = this.querySelectorAll('theme-swiper-breakpoint');
    breakpoints.forEach(breakpoint => {
      customElements.upgrade(breakpoint);
    });

    const swipers = this.querySelectorAll('theme-swiper');
    swipers.forEach(swiper => {
      customElements.upgrade(swiper);
      swiper.init();
    });
  }
}
if (!window.customElements.get("section-recommended")) {
  window.customElements.define("section-recommended", SectionRecommended);
}

class ZendeskForm extends ThemeForm {
  fields; zendesk;
  static TICKET_URL = '/api/v2/requests';
  static ATTACHMENT_URL = '/api/v2/uploads';
  static selectors = {
    successTemplate: '[data-success-template]',
    successMessage: '[data-success]',
  }

  constructor () {
    super();
    this.zendesk = this.dataset.zendesk;
    this.successTemplate = this.querySelector(ZendeskForm.selectors.successTemplate);

  }

  getFields = () => {
    const formData = new FormData(this.form);
    this.fields = {
      request: {
        subject: formData.get('subject'),
        requester: { name: formData.get('name'), email: formData.get('email') },
        comment: {
          body: formData.get('body'),
        }
      }
    };
    const customFields = [];
    formData.forEach((value, key) => {
      const matches = key.match(/^custom\[(.+)\]$/);
      if (matches) {
        customFields.push({ id: Number(matches[1]), value: value });
      }
    });
    if(customFields.length > 0){
      this.fields.request.custom_fields = customFields;
    }
    if(formData.get('attachment').size > 0) {
      this.uploadAttachment(formData.get('attachment'));
    } else {
      this.createTicket();
    }
  }

  uploadAttachment = (field) => {
    const url = `${this.zendesk}${ZendeskForm.ATTACHMENT_URL}?filename=test.png`;
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: url,
      headers: { 
        'Content-Type': field.type, 
        "Authorization": `Basic ${btoa(`${this.dataset.username}/token:${this.dataset.token}`)}`
      },
      data : field
    };
    axios.request(config).then((response) => {
      if(response.data.upload.token != undefined){
        this.fields.request.comment.uploads = [response.data.upload.token];
        this.createTicket();
      } else {
        this.form.attachment.closest('input-text').validateServer(this.dataset.fileError);
      }
    }).catch((error) => {
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: error }));
      this.form.attachment.closest('input-text').validateServer(this.dataset.fileError);
    });
  }

  createTicket = () => {
    this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUBMIT));
    const url = `${this.zendesk}${ZendeskForm.TICKET_URL}`;
    axios.post(url, JSON.stringify(this.fields), {
      headers: {
        'Content-Type': 'application/json',
        "Accept": "application/json",
        "Authorization": `Basic ${btoa(`${this.dataset.username}/token:${this.dataset.token}`)}`
      }
    })
    .then(response => {
      this.success(response.data.request.id);
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_SUCCESS, { detail: response }));
    })
    .catch(error => {
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_ERROR, { detail: error }));
      Utils.errorHanlder(error);
    })
    .finally(() => {
      this.hideLoader();
      this.dispatchEvent(new CustomEvent(Utils.E_FORM_SENT));
      this.form.reset();
    });
  }

  ajaxSubmit = () => {
    this.getFields();
  }

  success = (ticketId) => {
    if(this.successMessage != undefined){
      this.successMessage.remove();
    }
    const template = this.successTemplate.innerHTML.replaceAll('{ticket}', ticketId);
    this.insertAdjacentHTML('afterbegin', template);
    this.successMessage = this.querySelector(ZendeskForm.selectors.successMessage);
  }
}
if (!window.customElements.get("zendesk-form")) {
  window.customElements.define("zendesk-form", ZendeskForm);
}

class VideoPoster extends HTMLElement {
  frame; poster;
  
  constructor() {
    super();
    this.frame = this.querySelector('iframe');
    this.poster = this.querySelector('[data-poster]');
    this.init();
  }

  init = () => {
    if(this.poster != undefined){
      this.poster.addEventListener('click', () => this.playVideo());
    }
  }

  playVideo = () => {
    const url = new URL(this.frame.src);
    url.searchParams.set('autoplay', '1');
    this.frame.src = url.toString();
    this.poster.classList.add('d-none');
  }
}
if (!window.customElements.get("video-poster")) {
  window.customElements.define("video-poster", VideoPoster);
}